module.exports = __webpack_public_path__ + "img/index-section6-friend8_a.bb64c8a2.svg";